<template>
  <v-layout row justify-center>
    <v-dialog v-model="taskDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Task Settings</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <p
                  class="subheading red--text"
                >Default settings are already chosen. You can edit as needed.</p>
              </v-flex>

              <v-flex xs6 v-show="_.includes(['labeling','dataDebugger'],$route.name)">
                <v-select
                  v-model="classifierNames"
                  :items="classifiers"
                  attach
                  chips
                  label="Classifiers"
                  multiple
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                  :items="attributionsViewTypes"
                  label="Attribution View"
                  v-model="attributionsView"
                ></v-select>
              </v-flex>
              <v-flex xs6 v-show="_.includes(['labeling','dataDebugger'],$route.name)">
                <v-select :items="datasets" label="Dataset" v-model="selectedDataset"></v-select>
              </v-flex>

              <v-flex xs6>
                <v-select
                  :items="selectionMethods.user"
                  label="Selection Method"
                  v-model="selectionMethod"
                  v-show="_.includes(['labeling'],$route.name)"
                ></v-select>
              </v-flex>

              <v-flex xs12 mt-2 v-show="_.includes(['labeling'],$route.name)">
                <p class="body-2">Optional Settings</p>
              </v-flex>

              <v-flex xs12 sm4 v-show="_.includes(['labeling'],$route.name)">
                <v-text-field v-model="maxWords" attach type="number" min="0" label="Maximum Words"></v-text-field>
              </v-flex>

              <v-flex xs12 mt-2 v-show="_.includes(['interact'],$route.name)">
                <p class="body-2">Classifiers Configuration</p>
              </v-flex>

              <v-flex
                v-for="(classifierConfig, classifierName, i) in classifiersConfigs"
                :key="i"
                xs12
                v-show="_.includes(['interact'],$route.name)"
              >
                <v-flex
                  xs12
                  v-if="classifierConfig.c==='pritext.predictors.local.privately.PrivatelyPredictor'"
                >
                  <v-text-field
                    v-model="classifierConfig.kwargs.run_id"
                    attach
                    :label="classifierName"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  xs12
                  v-else-if="classifierConfig.c==='pritext.predictors.local.emosent_ensemble.EmoSentEnsemble'"
                  v-for="(ensembleMember,j) in classifierConfig.kwargs.kwargs_list"
                  :key="j"
                >
                  <v-text-field
                    v-model="ensembleMember.run_id"
                    attach
                    :label="classifierName +' member'"
                  ></v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="startLabeling()">Accept & Start</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>



<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
  data() {
    return {};
  },
  props: {
    openAtStart: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters("labeling", {
      selectionMethods: "selectionMethods",
      attributionsViewTypes: "attributionsViewTypes",
      classifiersConfigs: "classifiersConfigs",
      classifiers: "classifiers",
      datasets: "datasets",
      debuggerMode: "debuggerMode"
    }),
    _() {
      return _;
    },
    selectionMethod: {
      get() {
        return this.$store.getters["labeling/selectionMethod"];
      },
      set(value) {
        this.$store.dispatch("labeling/setSelectionMethod", value);
      }
    },
    taskDialog: {
      get() {
        return this.$store.getters["labeling/taskDialog"];
      },
      set(value) {
        this.$store.dispatch("labeling/setTaskDialog", value);
      }
    },
    selectedDataset: {
      get() {
        return this.$store.getters["labeling/selectedDataset"];
      },
      set(value) {
        this.$store.dispatch("labeling/setSelectedDataset", value);
      }
    },
    attributionsView: {
      get() {
        return this.$store.getters["labeling/attributionsView"];
      },
      set(value) {
        this.$store.dispatch("labeling/setAttributionsView", value);
      }
    },
    maxWords: {
      get() {
        return this.$store.getters["labeling/maxWords"];
      },
      set(value) {
        this.$store.dispatch("labeling/setMaxWords", value);
      }
    },
    classifierNames: {
      get() {
        return this.$store.getters["labeling/classifierNames"];
      },
      set(value) {
        this.$store.dispatch("labeling/setClassifierNames", value);
      }
    }
  },
  methods: {
    ...mapActions("labeling", {
      setTasksSettingsLoaded: "setTasksSettingsLoaded",
      setTaskDialog: "setTaskDialog",
      getTasksSettings: "getTasksSettings",
      fetchNewTasks: "fetchNewTasks"
    }),
    startLabeling() {
      let self = this;
      this.fetchNewTasks().then((self.taskDialog = false));
    }
  },
  mounted() {
    let self = this;
    
    self.getTasksSettings().then(() => {

      self.setTasksSettingsLoaded(true);
      self.setTaskDialog(self.openAtStart);
    });
    // this.startLabeling()
  }
};
</script>

<style>
</style>
